const filterChanged = (state, action) => {
  return {
    ...state,
    [action.model]: action.filter,
  };
};

export default (state = {}, action) => {
  switch (action.type) {
    case 'FILTER_CHANGED':
      return filterChanged(state, action);
    case 'LOGOUT':
      return {};
    default:
      return state;
  }
};
